/**
 * Created by brycemeyer on 9/20/16.
 */

class ColorBox {

    constructor() {


        // The content for the close button
        this.close = 'x';

        // The size dimensions for this pop up
        this.width = '96%';
        this.maxWidth = '778px';
        this.maxHeight = '90%';

        // Whether or not the pop up should be fixed within the viewport
        this.fixed = true;

        // Positioning of the pop up
        this.top = '104px';

        // The data to send when this is submitted
        this.data = {'ajax': true};

        this.dismiss = function() {
            if (typeof jQuery.colorbox == "function")
                jQuery.colorbox.close();
        }

        this.onOpen = function() {

            jQuery("body").css({overflow: "hidden"});
            jQuery("html").css({overflow: "hidden"});
        }

        this.onComplete = function () {
            ColorBox.setupContentLinks();

            jQuery("#cboxWrapper").css({"display": "block"});
        }

        this.onCleanup = function() {
            jQuery("body").css({overflow: "auto"});
            jQuery("html").css({overflow: "auto"});
            jQuery("#cboxWrapper").css({"display": "none"});
        }

        var $popupLinks = jQuery("a[data-popup_page=true]");

        if (typeof ColorBox.popUpInstance == 'undefined') {
            ColorBox.popUpInstance = jQuery.colorbox;
        }

        if (typeof $popupLinks.colorbox == 'undefined') {
            $popupLinks.colorbox = ColorBox.popUpInstance;
        }

        if (typeof $popupLinks != 'undefined' && $popupLinks.length > 0) {
            $popupLinks.colorbox(this);
        }
    }

    static setupContentLinks() {

        var $anchors = jQuery("#cboxContent").find("a");

        var isAbsolute = new RegExp('^\/', 'i');

        $anchors.each(function (index, anchor) {

            var $anchor = jQuery(anchor);
            if ($anchor.attr("target") != "blank") {
                var href = $anchor.attr("href");

                if (isAbsolute.test(href)) {
                    ColorBox.checkIfLinkIsOnPage(href, $anchor);
                }

                for (var i = 0; i < siteUrls.length; i++) {
                    var url = siteUrls[i];

                    if (href.includes(url)) {
                        var linkSlug = href.replace('/http.*\/\/(.*?)(?=\/)/', '');

                        ColorBox.checkIfLinkIsOnPage(linkSlug, $anchor);

                    }
                }
            }

        });
    }

    static checkIfLinkIsOnPage (slug, $anchor) {

        var splitAddress = window.location.pathname.replace('\?.*', '').split('/').remove("");
        var splitSlug = slug.replace('\?.*', '').split('/').remove("");

        if (splitSlug.compare(splitAddress)) {
            $anchor.click(function(event) {
                event.preventDefault();
                ColorBox.popUpInstance.close();
            });
        }
    }
}
